import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const subventionRoutes: MenuInterface[] = [
    {
        code: 'GestionConsultationMouvementsConsommations_View_Model',
        route: [
            {
                content: 'subvention/consumer-movement/filters',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionParametrageEnveloppeBudget_ViewModel',
        route: [{content: 'subvention/envelope/list', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionSubventionConsulterSolde_ViewModel',
        route: [{content: 'subvention/consumer-sales/filters', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionAttributionSubvention_ViewModel',
        route: [
            {
                content: 'subvention/allocation/list',
                focus: 'empty',
            },
            'content'
        ]
    },
];
